import React, { useEffect, useState } from 'react';
import SelectWithLabelOption from './components/SelectWithLabelOption';
import { LANGUAGE_OPTIONS } from './constants/SearchTutor';
import TutorCard from './components/TutorCard';
import Tutors from './data/Tutors.json';
import BookingModal from './components/BookingModal';
import CustomModal from '../../Components/CustomModal';
import CustomSelect from '../../Components/CustomSelect';
import { Footer } from '../../Components/Footer';
import OrangeButton from '../../Components/buttons/orange-button';
import HeroContainer from '../../Components/ui/hero-container';
import PriceSlider from './components/PriceSlider';
import SearchTutorInput from './components/SearchTutorInput';
import Availability from './components/Availability';
import ZipModal from '../../Components/ui/zip-modal';
import Pagination from '../../Components/ui/pagination';
import HeaderAlt from '../../Components/HeaderAlt';
import axios from 'axios';

const steps = [
  {
    icon: (
      <img
        src="/images/icons/binoculars.svg"
        alt="binoculars"
        className="h-12 w-12 text-[#5CD2C6]"
      />
    ),
    text: 'Find a suitable tutor',
  },
  {
    icon: (
      <img src="/images/icons/headset.svg" alt="headset" className="h-12 w-12 text-[#5CD2C6]" />
    ),
    text: 'Book your first lesson',
  },
  {
    icon: <img src="/images/icons/laptop1.svg" alt="laptop" className="h-12 w-12 text-[#5CD2C6]" />,
    text: 'Subscribe and learn independently',
  },
];

const TutorBrowserPage = () => {
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [tutorName, setTurorName] = useState('');
  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(null);
  const [toggle, setToggle] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [paginatedData, setPaginatedData] = useState([]);
  const [tutorCards, setTutorCards] = useState([]);

  const [range, setRange] = useState({ minValue: 10, maxValue: 1000 });
  const [language, setLanguage] = useState(LANGUAGE_OPTIONS?.[0]?.value || '');
  const [startTime, setStartTime] = useState('');
  const [tutorSearchQuery, setTutorSearchQuery] = useState('');
  const [endTime, setEndTime] = useState('');
  // Callback function to get paginated data
  const handlePageChange = (data) => {
    setPaginatedData(data);
  };

  const LABELS = ['I want to learn', 'Price per lesson', 'Availability', 'Type'];

  function capitalizeWords(input) {
    if (input === null || input === undefined) {
      return null;
    } else {
      return input.replace(/\b\w/g, (char) => char.toUpperCase());
    }
  }

  function capitalizeArray(strings) {
    return strings.map(capitalizeWords);
  }

  async function fetchTutorCards() {
    try {
      const response = await axios.get(
        'https://4r2btbgx96.execute-api.us-east-1.amazonaws.com/dev/get-tutors'
      );
      const unformattedTutorCards = JSON.parse(response.data.body);
      const formattedTutorCards = [];

      for (let i = 0; i < unformattedTutorCards.length; i++) {
        const unformattedTutorCard = unformattedTutorCards[i];
        const formatCard = (card) => {
          return {
            tutorId: card.tutor_id,
            name: card.full_name,
            bio: card.bio,
            hourlyRate: card.hourly_rate,
            academicSubjects: capitalizeArray(card.academic_subjects),
            coachingAreas: capitalizeArray(card.coaching_areas),
            academicBackground: {
              highSchool: capitalizeWords(card.background_high_school),
              undergraduate: capitalizeWords(card.background_undergraduate),
            },
            tutorProfileFiles: {
              introVideo: card.has_intro_video,
              profilePicture: card.has_profile_picture,
              resume: card.has_resume,
            },
            profilePictureSrc: card.prof_pic_source_url,
            testPrepCertifiedACT: Math.random() >= 0.5, // Random true/false
            testPrepCertifiedSAT: Math.random() >= 0.5, // Random true/false
          };
        };

        const formattedCard = formatCard(unformattedTutorCard);
        formattedTutorCards.push(formattedCard);
      }

      return formattedTutorCards;
    } catch (error) {
      return []; // Return an empty array on failure
    }
  }

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const cards = await fetchTutorCards();
        setTutorCards(cards); // Uncomment to set the cards into state
      } catch (error) {
        console.error(error, 'Error');
      }
    };
    fetchCards();
  }, []);

  // useEffect(() => {
  //     async function handleBackendTest() {
  //         try {
  //             const response = await axios.get('https://4r2btbgx96.execute-api.us-east-1.amazonaws.com/dev/get-tutors');
  //             console.log("Backend Test Response is: " + response)
  //             console.log(JSON.parse(response.data.body))
  //             setBackendTest(JSON.parse(response.data));
  //         } catch (error) {
  //             setBackendTest('Backend Test Failed: ' + error.message);
  //         }
  //     };
  //     handleBackendTest();
  // }, [])

  function bookAppointment(tutor) {
    setTurorName(tutor);
    setShowAppointmentModal(true);
  }
  function onModalCLose() {
    setShowAppointmentModal(false);
    setStep(1);
    setSelectedTime(new Date());
    setSelectedDate(null);
  }

  return (
    <>
      <HeaderAlt />
      <div className="flex flex-col gap-6 bg-[#f7f7f7]">
        <HeroContainer className="container !mt-10 !bg-[#f7f7f7] md:!mt-[59px] ">
          <div className="w-full max-w-[610px] space-y-6">
            <h1 className="hero-title fredokaOne font-normal !text-[#012E33]">
              Find best quality tutors for private lessons
            </h1>
            <p className="fredoka text-[19px] font-medium leading-[32px]  tracking-[-0.22px] text-[#678285] md:text-[22px]">
              Looking for an online tutor? We have the leading tutors
            </p>
          </div>
        </HeroContainer>
        <div className="container flex w-full flex-col gap-4">
          <div className="mx-auto flex w-full flex-col  gap-2 md:flex-row">
            <div className="relative flex min-w-full flex-col gap-5 rounded-[16px] bg-[#f7f7f7] md:flex-row">
              <div className="w-full">
                <SearchTutorInput
                  tutorSearchQuery={tutorSearchQuery}
                  setTutorSearchQuery={setTutorSearchQuery}
                />
              </div>
              <div className="w-full md:w-[261px]">
                <OrangeButton label={'Search'} className="w-full" />
              </div>
            </div>
          </div>
        </div>
        <CustomModal isOpen={showAppointmentModal} onClose={onModalCLose}>
          <BookingModal
            setStep={setStep}
            step={step}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            tutorname={tutorName}
            setShowAppointmentModal={setShowAppointmentModal}
          />
        </CustomModal>
        {/* <div className='p-4'>
                <Promo />
            </div> */}
        <main className="container space-y-4 rounded-[24px] !pb-6 ">
          {toggle && (
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <CustomSelect
                className="w-full"
                options={LANGUAGE_OPTIONS}
                onSelect={(value) => setLanguage(value)}
              >
                <SelectWithLabelOption label={LABELS[0]} option={language} />
              </CustomSelect>
              <PriceSlider setRange={setRange} range={range} />
              <Availability
                setEndTime={setEndTime}
                setStartTime={setStartTime}
                endTime={endTime}
                startTime={startTime}
                CustomSelect={CustomSelect}
                SelectWithLabelOption={SelectWithLabelOption}
                LABELS={LABELS}
              />
              <ZipModal />
            </div>
          )}
          <div
            className="mx-auto flex w-fit  cursor-pointer items-center justify-center gap-2"
            onClick={() => setToggle(!toggle)}
          >
            <h2 className="fredoka text-lg font-semibold leading-[1.5] text-[#FC823E] ">
              Advanced Filters
            </h2>
            <img
              src="/images/icons/chevron-down.svg"
              alt=""
              className={`h-4 w-4 transform transition-transform duration-300 ${
                toggle ? 'rotate-180' : ''
              }`}
            />
          </div>

          <div className="mx-auto !mt-12 grid grid-cols-1 content-center gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {tutorCards?.map((tutor, index) => {
              return <TutorCard key={index} data={tutor} bookAppointment={bookAppointment} />;
            })}
          </div>
          <div className="!mt-10">
            <Pagination
              data={Tutors} // Pass full array
              itemsPerPage={1} // Number of items per page
              onPageChange={handlePageChange} // Callback to get paginated data
            />
          </div>
        </main>
        <div className="flex w-full flex-col items-center justify-center !space-y-16 rounded-2xl  bg-[#85D7D6] py-8 md:py-12">
          <h2 className="fredoka container text-center text-[40px] font-bold leading-normal tracking-[-0.8px] text-[#012E33]">
            How Tutoring <br /> Works
          </h2>
          <div className="container !mt-6 grid w-full grid-cols-1 gap-12 md:grid-cols-3 md:gap-0">
            {steps.map((step, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="mb-4 flex h-32 w-32 items-center justify-center rounded-full bg-white">
                  {step.icon}
                </div>
                <p className="fredoka text-wrap text-center text-[22px] font-medium leading-normal tracking-[-0.44px] text-[#012E33]">
                  {step.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TutorBrowserPage;
